

export const ContainerImageBottom=({pathName})=>{

    return(
        <div className='__container'>
            <div className='container-image-bottom'>
                <img src={require(`../../../../static/${pathName}`)}/>
            </div>
        </div>
    )
}